import { NgModule } from '@angular/core';

import { UserContextLoaderService } from '@hdms/shared/data-access';

import { APP_IMPORTS } from './app.imports';
import { APP_PROVIDERS } from './app.providers';
import { AppComponent } from './components/app.component';
import { EmptyComponent } from './components/empty.component';

@NgModule({
  declarations: [AppComponent, EmptyComponent],
  imports: APP_IMPORTS,
  providers: APP_PROVIDERS,
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private readonly userContextLoaderService: UserContextLoaderService) {
    // As SSR requires initialNavigation to be enabled, routing incl. guard
    // execution will happen already before AppComponent initializes.
    // Hence, it's required to initialize userContextLoader already in AppModule.
    this.userContextLoaderService.init();
  }
}
